import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    OnDestroy,
    Output
} from '@angular/core';
import {DomSanitizer, SafeUrl} from '@angular/platform-browser';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';

@Component({
    selector: 'app-image-upload',
    template: `
        <button mat-button type="button" (click)="FileDialogShouldOpen = !!$event.x && !!$event.y; input.click();">
            <img [src]="ImageSafeUrl" *ngIf="ImageSafeUrl; else placeholder" />

            <ng-template #placeholder>Bild</ng-template>
        </button>
        <input
               type="file"
               (change)="$event.target.files[0] && Change.next($event.target.files[0])"
               hidden
               #input
               accept="image/*"
               (click)="FileInputClick($event);"
        />
    `,
    styles: [
        `
                    :host {
                        /* min-width und min-height sind gesetzt, damit die Komponente nicht schrumpft */
                        width: 6.25rem;
                        min-width: 6.25rem;
                        height: 6.25rem;
                        min-height: 6.25rem;
        
                        color: white;
                        background-color: #bbb;
                        border: 1px dashed #eee;
                        border-radius: 5px;
                        overflow: hidden;
                    }
        
                    button {
                        width: 100%;
                        height: 100%;
                        padding: 0;
                    }
        
                    img {
                        width: 100%;
                        height: auto;
                    }
                `
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ImageUploadComponent implements OnDestroy {
    /** URL des anzuzeigenden Bildes; wird automatisch mit hochgeladenem Bild aktualisiert */
    @Input() ImageSafeUrl?: SafeUrl;

    /** (NN) Gibt die hochgeladene Bilddatei aus */
    @Output() Change = new EventEmitter<File>();

    /** Gibt einmalig einen Wert aus, wenn die Komponente zerstört wird */
    private onDestroy$ = new Subject<void>();
    public FileDialogShouldOpen = false;
    constructor(private sanitizer: DomSanitizer) {
        // Seiteneffekt: Aktualisiert das anzuzeigende Bild mit dem hochgeladenen Bild
        this.Change.pipe(takeUntil(this.onDestroy$)).subscribe(file => {
            this.ImageSafeUrl = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(file));
        });
    }
    ngOnDestroy() {
        this.onDestroy$.next();
    }

    // dies ist nötig um die componente auch in einem form nutzen zu können, da anstelle des submit der file upload geöffnet wird
    public FileInputClick = (event) => {
        if (this.FileDialogShouldOpen) {
            this.FileDialogShouldOpen = false;
            return true;
        }
        else {
            event.preventDefault();
            event.stopPropagation();
            return false;
        }
    }
}
